import { useState } from "react";
import Helmet from "react-helmet";
import { Link } from "react-router-dom";
import Select from "react-select";
import { LOGIN_ROUTE } from ".";
import { useAppService } from "../../hooks/use-app-service";
import { ErrorDiv, TextInput } from "../../_components";
import I18 from "../../_components/atoms/i18";
import { Button } from "../../_components/button.component";
import UIcon from "../../_components/uicon-component";
import constants from "../../_config/constants.config";
import continents from "../../_config/country-codes.config.json";
import { redirectToAuthUrl } from "../../_config/helper.config";
import { CommunityService } from "../../_service";
import { AuthService } from "../../_service/auth.service";
import "../../_styles/color/light-color.css";

export default function MobileAuthComponent({
  community,
  communityDetail,
  setUser,
  isRegister = false,
  redirectSubdomain = "",
  errorMessage = "",
  setErrorMessage = (e) => {},
  redirectURL = "",
  setAuthType = (e) => {},
}) {
  const [step, setStep] = useState(1);
  const [isFormSubmittable, setIsFormSubmittable] = useState(false); // to disable submit button
  const [countryCode, setCountryCode] = useState(
    community
      ? community.configurables[constants.COMMUNITY_DEFAULT_COUNTRY_CODE]
      : "+91"
  );
  const [mobile, setMobile] = useState(""); // to save mobile number
  const [restrictedForNewUser, setRestrictedForNewUser] = useState(false); // to restrict new user
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const { analyticsService } = useAppService();

  const sendOTPCaptchaProtect = () => {
    window?.grecaptcha?.ready(function () {
      window.grecaptcha
        .execute(process.env.REACT_APP_RECAPTCHA_SITE_KEY, { action: "submit" })
        .then(function (token) {
          sendOTP(token);
        });
    });
  };

  const sendOTP = (captchaToken) => {
    setIsLoading(true);
    AuthService.requestOTP(
      countryCode,
      mobile,
      community ? community.id : null,
      captchaToken
    )
      .then((response) => {
        // go to step 2
        setStep(2);
        setIsLoading(false);
      })
      .catch((error) => {
        if (error && error.response && error.response.status === 400) {
          setRestrictedForNewUser(true);
          analyticsService.track("mobile-register-attempt", {
            mobile: countryCode + mobile,
          });
        } else if (error && error.response) {
          if (error.response.data.message) {
            setError(error.response.data.message);
          }
          setRestrictedForNewUser(false);
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.errors &&
            error.response.data.errors.mobile
          ) {
            // setErrorMessage(error.response.data.errors.mobile[0]);
            setError(error.response.data.errors.mobile[0]);
          }
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.errors &&
            error.response.data.errors.countryCode
          ) {
            // setErrorMessage(error.response.data.errors.countryCode[0]);
            setError(error.response.data.errors.countryCode[0]);
          }
        }
        setIsLoading(false);
      });
  };

  // if community has third party auth details
  if (community && community.authRedirectUrl) {
    // redirect the user there for login
    redirectToAuthUrl(community);
  }

  return (
    <div>
      <Helmet>
        <script
          src={
            "https://www.google.com/recaptcha/api.js?render=" +
            process.env.REACT_APP_RECAPTCHA_SITE_KEY
          }></script>
      </Helmet>
      {step === 1 ? (
        <LoginStep1
          communityDetail={communityDetail}
          countryCode={countryCode}
          setCountryCode={setCountryCode}
          setMobile={setMobile}
          isLoading={isLoading}
          isFormSubmittable={isFormSubmittable}
          setIsFormSubmittable={setIsFormSubmittable}
          redirectSubdomain={redirectSubdomain}
          redirectURL={redirectURL}
          sendOTP={sendOTPCaptchaProtect}
          isRegister={isRegister}
          setAuthType={setAuthType}
          error={error}
          restrictedForNewUser={restrictedForNewUser}
        />
      ) : (
        <LoginStep2
          communityDetail={communityDetail}
          countryCode={countryCode}
          mobile={mobile}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          setUser={setUser}
          setErrorMessage={setErrorMessage}
          setStep={setStep}
          sendOTP={sendOTP}
          isRegister={isRegister}
        />
      )}
    </div>
  );
}

/**
 * Step 1 of login
 * @param {*} param0
 * @returns
 */
function LoginStep1({
  communityDetail = null,
  countryCode = "+91",
  setCountryCode = (e) => {},
  setMobile = (e) => {},
  isLoading = false,
  isFormSubmittable = false,
  setIsFormSubmittable = (e) => {},
  redirectSubdomain = null,
  restrictedForNewUser = false,
  redirectURL = null,
  sendOTP = () => {},
  isRegister = false,
  setAuthType = (e) => {},
  error = "",
}) {
  const { analyticsService } = useAppService();
  return (
    <section key="1" className="LoginStep1">
      {/* FORM */}
      <div className="card theme-bg-surface">
        {/* COMMUNITY LOGO */}
        <>
          {communityDetail && communityDetail.logo ? (
            <div className="pensil-logo">
              <img src={communityDetail.logo} alt="" />
            </div>
          ) : redirectSubdomain ? (
            <></>
          ) : (
            <div className="pensil-logo">
              <img src="/assets/vectors/main-logo-square-blue.svg" alt="" />
            </div>
          )}
        </>
        {/* AUTH FLOW [ LOGIN | REGISTER ] */}
        <div className="font-semibold text-center theme-text-heading-2 text-lg pb-4">
          {isRegister ? "Register" : "Login"}
        </div>

        <p className="theme-text-heading-2 font-semibold text-center">
          Continue with your mobile no.
        </p>
        <div className="flex items-start gap-1 w-full my-3">
          {/* country code drop down */}

          <Select
            className="cursor-pointer theme-border-default theme-bg-surface theme-text-heading-2 rounded min-w-max outline-none w-4/12"
            defaultValue={countryCode}
            placeholder={countryCode}
            value={countryCode}
            onChange={(value) => {
              setCountryCode(value.value);
            }}
            name="color"
            options={continents}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                borderColor: "var(--theme-divider-color)",
                color: "var(--theme-default-text-color)",
                backgroundColor: "var(--theme-bg-surface)",
                cursor: "pointer",
              }),
              menu: (baseStyles, state) => ({
                ...baseStyles,
                color: "var(--theme-heading-2-text-color)",
              }),
              menuList: (baseStyles, state) => ({
                ...baseStyles,
                backgroundColor: "var(--theme-surface-color)",
                borderColor: "var(--theme-divider-color)",
              }),

              option: (styles, { data, isDisabled, isFocused, isSelected }) => {
                return {
                  fontFamily: data.label,
                  padding: "5px 10px",
                  ...styles,
                  backgroundColor: isSelected
                    ? "var(--theme-bg-primary)"
                    : "var(--theme-surface-color)",
                  cursor: "pointer",
                  color: "var(--theme-text-heading-2)",
                  ":hover": {
                    backgroundColor: "var(--theme-background-color)",
                    color: "var(--theme-heading-1-text-color)",
                  },
                };
              },
            }}
          />

          {/* input box */}
          <TextInput
            inputPattern={/^\d{0,15}$/}
            placeholder="Enter Mobile No."
            noMargin
            validator={(value) => {
              if (!/^\d{0,15}$/.test(value)) {
                setIsFormSubmittable(false);
                return "Mobile number is not valid!";
              } else {
                setIsFormSubmittable(true);
              }
            }}
            containerClassName="flex-1 "
            className="py-2 h-9"
            onChange={(value) => {
              setMobile(value);
            }}
          />
        </div>

        <div className="mb-3">
          {restrictedForNewUser ? (
            <div className="theme-text-danger text-xs pb-2 ">
              <I18>Please</I18>{" "}
              <Link
                to="/register"
                className="text-blue-600 underline"
                onClick={() => {
                  setAuthType("email");
                  analyticsService.track(
                    "mobile-register-attempt-redirect-email"
                  );
                }}>
                <I18>register via email</I18>
              </Link>
              <div>
                <I18>
                  We have discontinued the "Login via Mobile" for new user
                </I18>
              </div>
            </div>
          ) : (
            <ErrorDiv error={error} />
          )}
        </div>
        <div className="flex justify-center">
          <Button
            disabled={!isFormSubmittable}
            onClick={sendOTP}
            className="w-full py-2"
            isLoading={isLoading}
            label={isRegister ? "Get Started" : "Login"}
          />
        </div>
        {/* or */}
        <div className="or flex justify-center items-center">
          <span className="line"></span>
          <span className="text">or</span>
          <span className="line"></span>
        </div>
        {/* switch login */}
        <div className="mt-2">
          Want to use different method?{" "}
          <Link
            to={LOGIN_ROUTE + (redirectURL ? "?redirect=" + redirectURL : "")}
            onClick={(e) => {
              e.preventDefault();
              setAuthType(null);
            }}>
            Login
          </Link>
        </div>
      </div>

      {/* TERMS AND CONDITIONS */}
      <div className="pt-6">
        <div className="text-center theme-text-heading-2 text-xs pb-4 flex justify-between">
          <span>
            By clicking “Continue with Email/Start with Google/Start with
            Facebook” above, you acknowledge that you have read and understood,
            and agree to our&nbsp;
            <span>
              <a
                href={
                  communityDetail && communityDetail.termsAndConditionsLink
                    ? communityDetail.termsAndConditionsLink
                    : "https://www.pensil.in/terms-conditions"
                }>
                Terms &amp; Conditions
              </a>
            </span>
            &nbsp;and&nbsp;
            <span>
              <a
                href={
                  communityDetail && communityDetail.privacyPolicyLink
                    ? communityDetail.privacyPolicyLink
                    : "https://www.pensil.in/privacy-policy"
                }>
                Privacy Policy
              </a>
            </span>
          </span>
        </div>
      </div>
    </section>
  );
}

/**
 * Step 2 of login. Verify OTP
 * @param {*} param0
 * @returns
 */
function LoginStep2({
  communityDetail = null,
  countryCode = "",
  mobile = "",
  isLoading = false,
  setIsLoading = (e) => {},
  setUser = (e) => {},
  setStep = (e) => {},
  setErrorMessage = (e) => {},
  sendOTP = () => {},
  isRegister = false,
}) {
  const [otp, setOtp] = useState("");
  const { analyticsService } = useAppService();

  const [isFormSubmittable, setIsFormSubmittable] = useState(false); // to disable submit button

  const validateOTP = async () => {
    try {
      setIsLoading(true);
      // send otp to server
      const response = await AuthService.verifyOTP(
        countryCode,
        mobile,
        parseInt(otp)
      );

      const { user } = response;

      // save the user
      localStorage.setItem("pensil.user", JSON.stringify(response.user));

      // auto subscribe the community
      if (communityDetail) {
        try {
          const community = await CommunityService.getCommunityById(
            user,
            communityDetail.id
          );

          // subscribe the user if not subscribed
          if (community && !community.joined) {
            // subscribe to community
            await CommunityService.joinCommunity(user, community.id);
            analyticsService.track("subscribe-community", {});
          }
        } catch (error) {
          console.log({ error, message: "Loading community by id failed!" });
        }
      }

      // mixpanel event
      const properties = isRegister
        ? {
            mobile: mobile,
          }
        : {
            mobile: mobile,
            userName: user?.name,
          };

      analyticsService.track(isRegister ? "signup" : "login", properties);

      // set the user data
      setUser(response.user);
    } catch (error) {
      if (error && error.response && error.response.data.message) {
        if (error.response.data.errors.mobile) {
          setErrorMessage(error.response.data.errors.mobile[0]);
        }
        if (error.response.data.errors.otp) {
          setErrorMessage(error.response.data.errors.otp[0]);
        }
      }
      setIsLoading(false);
    }
  };

  return (
    <div
      key="2"
      className="card theme-bg-surface"
      style={{
        paddingTop: "1rem",
      }}>
      {communityDetail && communityDetail.logo ? (
        <div className="pensil-logo">
          <img src={communityDetail.logo} alt="" />
        </div>
      ) : (
        <div className="pensil-logo">
          <img src="/assets/vectors/main-logo-white.svg" alt="" />
        </div>
      )}
      <div
        className="flex items-center my-2 pb-8 cursor-pointer space-x-4"
        onClick={(e) => {
          setStep(1);
        }}>
        <UIcon icon="angle-left" />
        <span className="theme-text-heading-2 font-semibold">
          Confirm Mobile No.
        </span>
      </div>
      <span className="theme-text-heading-2 font-semibold">
        Please Enter the magic code sent on {countryCode}
        {mobile}
      </span>
      <div className="mt-2 focus:outline-none border theme-border-default rounded">
        <input
          type="text"
          maxLength={4}
          className="w-full rounded focus:outline-none bg-transparent py-3 flex text-center text-xl"
          value={otp}
          onChange={(e) => {
            if (/^[0-9]*$/.test(e.target.value)) {
              setOtp(e.target.value);
            }
            if (e.target.value.length === 4) {
              setIsFormSubmittable(true);
            } else {
              setIsFormSubmittable(false);
            }
          }}
        />
      </div>
      <div className="text-right mb-10">
        <span
          onClick={sendOTP}
          className="theme-text-primary cursor-pointer text-xs font-semibold px-1">
          Re-Send Code
        </span>
      </div>
      <div className="flex justify-center">
        <Button
          disabled={!isFormSubmittable}
          onClick={validateOTP}
          className="w-full py-2"
          isLoading={isLoading}
          label="Confirm"
        />
      </div>
    </div>
  );
}
